import io from 'socket.io-client';

const socketWpp = io(`${location.protocol}//${location.hostname}:4000`, {
  transports: ['websocket'],
  autoConnect: false
});

socketWpp.on('connect', () => {
  console.log('[socketWpp] conectado:', socketWpp.id);
  socketWpp.emit('realtime:join');
});

export default socketWpp;
